<div class="text-field form-input"
[ngClass]="{
    'predefined-value': predefinedStyleEnabled,
    'form-input--with-prefix-icon': fieldConfig.prefixIcon
    }">

    <mat-form-field *ngIf="fieldConfig.maskConfig"
                    [floatLabel]="floatLabel"
                    [appearance]="appearance">

        <img matPrefix
             *ngIf="fieldConfig.prefixIcon"
             class="form-input__prefix-icon"
             [src]="fieldConfig.prefixIcon">

        <input matInput
               [id]="id"
               (blur)="onBlurWithMask($event)"
               (input)="handleInputEvent($event)"
               (click)="onClick($event)"
               [autocomplete]="autocompleteAllowed ? fieldConfig.autocomplete : undefined"
               [readonly]="fieldConfig.readonly"
               [placeholder]="placeholder ? (placeholder | translate) : null"
               [formControl]="control"
               [type]="inputType"
               [name]="fieldConfig.key"
               [maxlength]="fieldConfig.maxlength"
               [mask]="mask"
               [dropSpecialCharacters]="dropSpecialCharacters"
               [sufix]="sufix"
        >

        <mat-label *ngIf="label">
            {{ label | translate }}
        </mat-label>

        <mat-icon matSuffix *ngIf="fieldConfig.properties!==undefined && fieldConfig.properties['matSuffix']">
            {{fieldConfig.properties['matSuffix']}}
        </mat-icon>

        <img *ngIf="suffixIcon"
             matSuffix
             [src]="suffixIcon" alt=""
             class="text-field__suffix-icon">

        <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)">{{ (context + '.' + fieldConfig.fieldKey + '.' +
            errorsMap.get(fieldConfig.fieldKey))|translate}}
        </mat-error>

        <mat-hint *ngIf="verificationHintVisible" class="predefined-value__color">{{'HINTS.verificationRequired' | translate}}</mat-hint>

    </mat-form-field>

    <mat-form-field *ngIf="!fieldConfig.maskConfig"
                    [floatLabel]="floatLabel"
                    [appearance]="appearance">

        <img matPrefix
             *ngIf="fieldConfig.prefixIcon"
             class="form-input__prefix-icon"
             [src]="fieldConfig.prefixIcon">

        <input appTextTransform
               matInput
               [id]="id"
               [autocomplete]="autocompleteAllowed ? fieldConfig.autocomplete : undefined"
               [config]="fieldConfig.properties"
               [readonly]="fieldConfig.readonly"
               (blur)="onBlurWithoutMask($event)"
               (input)="handleInputEvent($event)"
               (click)="onClick($event)"
               [type]="inputType"
               [placeholder]="placeholder ? (placeholder | translate) : null"
               [formControl]="control"
               [name]="fieldConfig.fieldKey"
               (keyup)="changeValue($event)"
               [maxlength]="fieldConfig.maxlength">

        <mat-label *ngIf="label">
            {{ label | translate }}
        </mat-label>

        <span *ngIf="fieldConfig.properties && fieldConfig.properties.dynamicSuffix" id="{{fieldConfig.fieldKey + '-dynamic-suffix'}}"
              class="dynamic-suffix">
            <span *ngIf="control.value" dynamicSuffix>{{fieldConfig.properties.dynamicSuffix}}</span>
        </span>

        <mat-icon matSuffix *ngIf="(fieldConfig.properties !== undefined) && fieldConfig.properties['matSuffix']">
            {{fieldConfig.properties['matSuffix']}}
        </mat-icon>

        <img *ngIf="suffixIcon"
             matSuffix
             [src]="suffixIcon" alt=""
             class="text-field__suffix-icon">

        <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)">{{ (context + '.' + fieldConfig.fieldKey + '.' +
            errorsMap.get(fieldConfig.fieldKey))|translate}}
        </mat-error>

         <mat-hint *ngIf="verificationHintVisible" class="predefined-value__color">{{'HINTS.verificationRequired' | translate}}</mat-hint>

    </mat-form-field>

    <div class="desc-icon">
        <app-tooltip-icon *ngIf="tooltipIconVisible"
                          [description]="fieldConfig.description">
        </app-tooltip-icon>
        <app-information-icon class="information-icon" *ngIf="informationIconVisible"
                              [information]="fieldConfig.predefined.additionalInfo | additionalInfo"
                              [description]="fieldConfig.description | translate">
        </app-information-icon>
    </div>
</div>
<canvas id="{{fieldConfig.fieldKey + '-canvas'}}" hidden></canvas>
